if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');

        if (!this.form) {
          console.error('Product form element not found.');
          return;
        }

        const idInput = this.form.querySelector('[name="id"]');

        if (idInput) {
          idInput.disabled = false;
        }

        this.form.addEventListener(
          'submit',
          this.onSubmitHandler.bind(this)
        );

        this.submitButton =
          this.querySelector('[type="submit"]');

        this.cart =
          document.querySelector('cart-drawer');

        this.hideErrors =
          this.dataset.hideErrors === 'true';

        this.error = false;
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (!this.submitButton) {
          return;
        }

        if (
          this.submitButton.getAttribute('disabled') ===
          'true'
        ) {
          return;
        }

        this.handleErrorMessage();

        this.error = false;

        /*
         * START LOADING
         */
        this.submitButton.setAttribute(
          'disabled',
          'true'
        );

        this.submitButton.classList.add(
          'loading'
        );

        this.querySelector(
          '.loading--spinner'
        )?.classList.remove('hidden');

        this.submitButton
          .querySelector(
            '[data-add-to-cart-text]'
          )
          ?.classList.add('hidden');


        /*
         * SHOPIFY AJAX CONFIG
         */
        const config =
          fetchConfig('javascript');

        config.headers[
          'X-Requested-With'
        ] = 'XMLHttpRequest';

        delete config.headers[
          'Content-Type'
        ];


        /*
         * FORM DATA
         */
        const formData =
          new FormData(this.form);


        /*
         * CART SECTIONS
         */
        const sections = [];

        const cartDrawer =
          document.querySelector(
            'cart-drawer'
          );

        if (cartDrawer) {
          sections.push(
            'cart-drawer'
          );
        }

        const mainCart =
          document.querySelector(
            '#main-cart'
          );

        if (mainCart) {
          const mainCartId =
            mainCart.dataset.id;

          if (mainCartId) {
            sections.push(
              mainCartId
            );
          }
        }


        /*
         * ADD SECTIONS TO REQUEST
         */
        if (sections.length > 0) {
          formData.append(
            'sections',
            sections.join(',')
          );

          formData.append(
            'sections_url',
            window.location.pathname
          );
        }

        config.body =
          formData;


        /*
         * ADD TO CART
         */
        fetch(
          `${routes.cart_add_url}`,
          config
        )
          .then((response) => {

            if (!response.ok) {
              throw new Error(
                `Add to cart request failed: ${response.status}`
              );
            }

            return response.json();
          })


          .then((response) => {

            /*
             * SHOPIFY ERROR
             */
            if (response.status) {

              publish(
                PUB_SUB_EVENTS.cartError,
                {
                  source:
                    'product-form',

                  productVariantId:
                    formData.get('id'),

                  errors:
                    response.description,

                  message:
                    response.message
                }
              );

              this.handleErrorMessage(
                response.description
              );

              this.error = true;

              return;
            }


            /*
             * CART DRAWER MUST EXIST
             *
             * NEVER REDIRECT TO LOGIN,
             * REGISTER OR CART.
             */
            if (!this.cart) {

              console.error(
                'Cart drawer not found on the page.'
              );

              this.error = true;

              this.handleErrorMessage(
                'Cart drawer could not be opened.'
              );

              return;
            }


            /*
             * CART UPDATE EVENT
             */
            publish(
              PUB_SUB_EVENTS.cartUpdate,
              {
                source:
                  'product-form',

                productVariantId:
                  formData.get('id')
              }
            );


            this.error = false;


            /*
             * HIDE STICKY BAR
             */
            const stickyBar =
              document.querySelector(
                '.product-sticky-bar'
              );

            if (stickyBar) {
              stickyBar.classList.remove(
                'is-visible'
              );
            }


            /*
             * USE NATIVE CART DRAWER
             */
            if (
              typeof this.cart
                .renderContents !==
              'function'
            ) {

              console.error(
                'cart-drawer.renderContents() is not available.'
              );

              this.error = true;

              this.handleErrorMessage(
                'Unable to open cart drawer.'
              );

              return;
            }


            /*
             * RENDER CART
             */
            this.cart.renderContents(
              response
            );


            /*
             * OPEN DRAWER
             */
            this.cart.classList.add(
              'is-visible'
            );


            /*
             * LOCK BODY SCROLL
             */
            const body =
              document.querySelector(
                'body'
              );

            if (body) {
              body.classList.add(
                'overflow-hidden'
              );
            }


            /*
             * SAVE FOCUS
             */
            window.focusElement =
              this.submitButton;
          })


          .catch((error) => {

            console.error(
              'Add to cart error:',
              error
            );

            this.error = true;

            this.handleErrorMessage(
              'Unable to add this item to your cart. Please try again.'
            );
          })


          .finally(() => {

            /*
             * ALWAYS STOP LOADING
             */
            if (this.submitButton) {

              this.submitButton.classList.remove(
                'loading'
              );

              this.submitButton.removeAttribute(
                'disabled'
              );

              this.submitButton
                .querySelector(
                  '[data-add-to-cart-text]'
                )
                ?.classList.remove(
                  'hidden'
                );
            }


            /*
             * HIDE SPINNER
             */
            this.querySelector(
              '.loading--spinner'
            )?.classList.add(
              'hidden'
            );


            /*
             * REMOVE EMPTY STATE
             */
            if (
              this.cart &&
              this.cart.classList.contains(
                'is-empty'
              )
            ) {
              this.cart.classList.remove(
                'is-empty'
              );
            }
          });
      }


      handleErrorMessage(
        errorMessage = false
      ) {

        if (this.hideErrors) {
          return;
        }


        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(
            '.product-form--error-message-wrapper'
          ) ||
          this.closest(
            'product-card'
          )?.querySelector(
            '.product-form--error-message-wrapper'
          );


        if (
          !this.errorMessageWrapper
        ) {
          return;
        }


        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form--error-message'
          ) ||
          this.closest(
            'product-card'
          )?.querySelector(
            '.product-form--error-message'
          );


        if (!this.errorMessage) {
          return;
        }


        this.errorMessageWrapper.toggleAttribute(
          'hidden',
          !errorMessage
        );


        if (errorMessage) {
          this.errorMessage.textContent =
            errorMessage;
        }
      }
    }
  );
}